import * as React from "react";
import { Button, ModalConfirm, Text } from "@nordcloud/gnui";
import { showSuccess } from "~/components";
import { useShowError } from "~/components/Error/useShowError";
import { ServiceOffering } from "~/models/services";
import { generateActionSuccessText, useAxios } from "~/tools";

type Props = {
  offering: ServiceOffering;
  refetch: () => Promise<void>;
};

export default function ({ offering, refetch }: Props) {
  const [open, setOpen] = React.useState(false);

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const deleteOffering = async () => {
    try {
      await Axios().delete(`/service-offerings/${offering.id}`);
      showSuccess(
        generateActionSuccessText(`Service offering ${offering.name}`)()(
          "deleted"
        )()
      );
      setOpen(false);

      return refetch();
    } catch (e) {
      showError(e.response);
    }
  };

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        onClick={() => setOpen(true)}
        severity="low"
      >
        Delete
      </Button>

      <ModalConfirm
        onClose={() => setOpen(false)}
        isOpen={open}
        confirm={deleteOffering}
        actionLabel="Delete"
        contentLabel={`Delete service offering ${offering.name}`}
      >
        <Text color="warning">
          Are you sure you want to delete service {offering.name}?
        </Text>

        {offering.services.length > 0 && (
          <Text color="danger">
            WARNING - All related services and requests will also be deleted.
          </Text>
        )}
      </ModalConfirm>
    </>
  );
}
